/* eslint-disable no-console */
import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import {
  HeaderText,
  DropdownMaterial,
  MultipleChoice,
  SingleChoice
} from '@splunk-iteng/splunk-shared-components'
import { useGetAppAttributeQuery } from '../../graphql/graphql'

interface ABACPreviewProps {
  AppName: string
}

type AppAttribute = {
  app_name: string
  attribute_order: number
  attribute_is_required: boolean
  attribute_key: string
  attribute_value: string
  attribute_type: string
}

export function ABACPreviewer({ AppName }: ABACPreviewProps) {
  const [appName, setAppName] = useState(AppName)
  const [searchParams] = useSearchParams()
  const [appAttribute, setAppAttribute] = useState<AppAttribute[]>([])

  const { error: appAttributeError, data: appAttributeData } =
    useGetAppAttributeQuery({
      fetchPolicy: 'no-cache',
      variables: { appName },
      skip: !appName || appName === ''
    })

  useEffect(() => {
    const query = searchParams.get('AppName') ?? ''
    setAppName(query)
  }, [searchParams])

  useEffect(() => {
    if (appAttributeData?.getAppAttribute?.data) {
      const existingApp = appAttributeData?.getAppAttribute?.data
      setAppAttribute(existingApp)
    }
  }, [appAttributeData])

  useEffect(() => {
    if (appAttributeError) alert(appAttributeError.message)
  }, [appAttributeError])

  const preventEnter = async (e: React.FormEvent) => {
    e.preventDefault()
  }

  return (
    <form onSubmit={preventEnter}>
      {appAttribute.length <= 0 ? (
        <div>Nothing to preview</div>
      ) : (
        <div>
          {appAttribute.map((item) => {
            switch (item.attribute_type) {
              case 'header':
                return (
                  <HeaderText
                    key={uuidv4()}
                    data={{
                      header: item.attribute_key,
                      subheader: JSON.parse(item.attribute_value)[0]
                    }}
                  />
                )
              case 'multipleChoice':
                return (
                  <MultipleChoice
                    key={uuidv4()}
                    onChangeCallback={() => {}}
                    data={{
                      question: item.attribute_key,
                      answers: item.attribute_value
                    }}
                  />
                )
              case 'enum':
                return (
                  <DropdownMaterial
                    key={uuidv4()}
                    onChangeCallback={() => {}}
                    data={{
                      question: item.attribute_key,
                      answers: item.attribute_value
                    }}
                  />
                )
              case 'singleChoice':
                return (
                  <SingleChoice
                    key={uuidv4()}
                    onChangeCallback={() => {}}
                    data={{
                      question: item.attribute_key,
                      answers: item.attribute_value
                    }}
                  />
                )
              default:
                return <div />
            }
          })}
          <div className="attribute-page-h2">
            <button
              type="button"
              className="splunk-btn-common splunk-btn-black"
              onClick={() => {}}
              style={{ marginRight: 10 }}
            >
              Skip and Finish Later
            </button>
            <button
              type="button"
              className="splunk-btn-common splunk-btn-magenta"
              onClick={() => {}}
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="splunk-btn-common splunk-btn-magenta-solid"
              onClick={() => {}}
              disabled
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </form>
  )
}
